import { useFormikContext } from 'formik'
import React from 'react'
import { Button } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { IconBack } from 'src/app/modules/component/IconSvg'
import InfoPatientRight from 'src/app/modules/phan-he-kham-benh/components/InfoPatientRight'
import { ServiceTemplateButton } from 'src/app/modules/phan-he-kham-benh/components/service-template-button'
import { handleConvertBenhNhanInfo } from 'src/app/modules/phan-he-noi-tru/common/functionCommon'
import { ORDER_TYPE_ID } from 'src/app/modules/utils/Constant'
import { parseJSON } from 'src/app/modules/utils/FormatUtils'
import { usePhanHeDieuTriNoiTruContext } from '../../PhanHeDieuTriContext'

type Props = {
    onClose: () => void;
    tableData: any[];
    setTableData: (data: any[]) => void;
    setKhoThuocSelected: (data: any) => void;
    isEdit?: boolean;
}

const HeaderThuoc = (props: Props) => {
    const { onClose, tableData, setTableData, setKhoThuocSelected, isEdit } = props;
    const { benhNhanDieuTri } = usePhanHeDieuTriNoiTruContext();
    const { values } = useFormikContext<any>();


    const getDonMauParams = () => {
        const formValue = JSON.stringify(values);
        const tableValue = tableData.map((row) => ({
            orderType: parseInt(ORDER_TYPE_ID.THUOC_DIEU_TRI),
            orderTemplate: JSON.stringify({
                ...row,
                inventoryItemId: null
            }),
        }));

        return {
            orderType: parseInt(ORDER_TYPE_ID.THUOC_DIEU_TRI),
            orderTemplate: formValue,
            lstOrderSetMemebers: tableValue,
        };
    };

    const onSelectMauChiDinhThuoc = (data: any) => {
        const tableValue = data.lstOrderSetMemebers.map((row: any) => ({
            ...JSON.parse(row.orderTemplate),
        }));
        const orderTemplateData = parseJSON(data.orderTemplate);
        setKhoThuocSelected({
            id: orderTemplateData.khoThuocId,
            name: orderTemplateData.khoThuocName,
            warehouseType: orderTemplateData.khoThuocType,
        });
        setTableData(tableValue);
    };

    const saveDonMauValidation = () => {
        if (!tableData.length) {
            toast.warn('Chưa có thuốc được kê cho mẫu này');
            return false;
        }

        return true;
    };

    const selectDonMauValidation = () => {
        if (tableData.length) {
            toast.warn('Đã có thuốc được chỉ định. Không thể chọn đơn mẫu');
            return false;
        }
        return true;
    };

    return (
        <>
            <div className="d-flex align-items-center gap-6">
                <Button
                    variant="bg-transparent ps-0 d-flex align-items-center"
                    onClick={onClose}
                >
                    <IconBack />
                    <span className="fw-500 ps-2">Quay lại</span>
                </Button>
                <ServiceTemplateButton
                    label="Đơn thuốc mẫu"
                    getSaveParams={getDonMauParams}
                    onSelectMau={onSelectMauChiDinhThuoc}
                    orderType={parseInt(ORDER_TYPE_ID.THUOC_DIEU_TRI)}
                    onSaveValidationFn={saveDonMauValidation}
                    onSelectValidationFn={selectDonMauValidation}
                    allowAdd={!isEdit}
                />
            </div>
            {benhNhanDieuTri ? (
                <InfoPatientRight benhNhanInfo={handleConvertBenhNhanInfo(benhNhanDieuTri)} />
            ) : (
                <div className="spaces h-65"></div>
            )}
        </>
    )
}

export default HeaderThuoc